import { useQuery } from "@tanstack/react-query";
import { recruitersService } from "@/services/recruitersService";

// query keys
export const recruitersQueryKeys = {
  all: ["recruiters"],
  list: () => [...recruitersQueryKeys.all, "list"],
  details: (id) => [...recruitersQueryKeys.all, "detail", id],
  
};


// get all recruiters
export const useAllRecruiters = () => {
  return useQuery({
    queryKey: recruitersQueryKeys.list(),
    queryFn: () => recruitersService.getAllRecruiters(),
  });
};    

// get all recruiter companies
export const useAllRecruiterCompanies = () => {
  return useQuery({
    queryKey: recruitersQueryKeys.list(),
    queryFn: () => recruitersService.getRecruiterCompanies(),
  });
};





// get company of recruiter
export const useCompanyOfRecruiter = (params) => {
  return useQuery({
    queryKey: recruitersQueryKeys.list(),
    queryFn: () => recruitersService.getCompanyOfRecruiter(params),
  });
};

